// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rPp-","top":"styles_top__42A3i"};